<div class="fix-width bg-white flex column radius padding margin-top-largest shadow">
	<div class="flex center margin-bottom">
		<img src="https://basicplatformblob.blob.core.windows.net/resources/LOGOS/BASICNET.PNG" />
	</div>

	<div class="margin-bottom-small">
		Please select your
		<b>Company</b>
		:
	</div>

	<input type="text" placeholder="Company select" matInput [formControl]="companyNameControl" [matAutocomplete]="auto" (keydown.enter)="$event.preventDefault()" />
	<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCompany" (optionSelected)="(null)">
		@for (company of companies; track company) {
			<mat-option inViewport (inViewportAction)="inViewportAction($event, company)" [value]="company">{{ company.name }}</mat-option>
		}
	</mat-autocomplete>

	<div class="flex column end margin-top">
		<button (click)="companySelection()" [disabled]="!this.companyNameControl.value">
			<i class="fa fa-check margin-right-small"></i>
			Confirm
		</button>
	</div>
</div>
